import { WorkplaceRemindersSection } from "@/components/messages/WorkplaceRemindersSection";

type Props = {
  leadId: string;
};

/** Lead-scoped workplace reminders (WC-X3) — unified model from ops notifications. */
export function LeadWorkplaceRemindersSection({ leadId }: Props) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white px-3 py-2.5 dark:border-zinc-700 dark:bg-zinc-950/40">
      <p className="text-[11px] font-semibold text-gray-800 dark:text-gray-100 mb-2">Workplace reminders</p>
      <WorkplaceRemindersSection surface="lead" leadId={leadId} compact />
    </div>
  );
}
